export const SELECTION_TRACKING_CONTENT_READY = 'selection-tracking:content-ready';

export class TrackTextSelection {
    constructor(domRoot, params) {
        this.root = domRoot;
        this.elementToTrack = document.querySelector(params.elementToTrack) || this.root;
        this.gtmParams = params.gtm;
        this.fullContentToCompareWithSelection = (this.elementToTrack.value || this.elementToTrack.innerHTML || '').trim();
        this.contentToTrackIsAsync = params.contentToTrackIsAsync || false;
        this.trackFullSelection = params.trackFullSelection === false ? params.trackFullSelection : true;

        this.triggerEventIfParamsAreValid = this.triggerEventIfParamsAreValid.bind(this);
        this.onSelectionTrackingContentReady = this.onSelectionTrackingContentReady.bind(this);

        this.init();
    }

    init() {
        if (this.contentToTrackIsAsync) {
            Hop.events.on(SELECTION_TRACKING_CONTENT_READY, this.onSelectionTrackingContentReady);
        } else {
            this.listenToMouseup();
        }
    }

    onSelectionTrackingContentReady(fullContentToCompareWithSelection) {
        if (fullContentToCompareWithSelection) {
            this.fullContentToCompareWithSelection = fullContentToCompareWithSelection;
        }

        this.listenToMouseup();
    }

    triggerEventIfParamsAreValid() {
        if (this.gtmParams) {
            const selectionIsValidAccordingToParams =
                // we wan't to track the full selection, and we have selected all the content
                (this.trackFullSelection && this.fullContentToCompareWithSelection === this.getSelectedText())
                // we  don't wan't to track the full selection, and we have not selected all the content
                || (this.trackFullSelection === false && this.fullContentToCompareWithSelection !== this.getSelectedText());

            if (selectionIsValidAccordingToParams) {
                this.gtmPush();
            }
        } else {
            this.logErrorParams();
        }
    }

    getSelectedText() {
        if (window.getSelection) {
            return this.elementToTrack.value.substring(this.elementToTrack.selectionStart, this.elementToTrack.selectionEnd);
        } else if (document.selection) {
            return document.selection.createRange().text;
        }
        return '';
    }

    listenToMouseup() {
        this.elementToTrack.addEventListener('mouseup', this.triggerEventIfParamsAreValid);
    }

    destroy() {
        this.elementToTrack.removeEventListener('mouseup', this.triggerEventIfParamsAreValid);
        Hop.events.on(SELECTION_TRACKING_CONTENT_READY, this.onSelectionTrackingContentReady);
    }

    gtmPush() {
        Hop.gtm.push(this.gtmParams);
    }

    logErrorParams() {
        return Hop.logError('Error with module params. Missing or incoherent ones');
    }
}
